export default __webpack_public_path__ + "static/media/HappyFace.6f472b61.png";